import { t } from '@/i18n';
import { z } from 'zod';

const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export const modalFormSchema = z
  .object({
    title: z.string().min(1, t('pages.application_store.components.product_store_edit_modal.schema.required')),
    price: z.string().min(1, t('pages.application_store.components.product_store_edit_modal.schema.required')),
    source_url: z.string().min(1, t('pages.application_store.components.product_store_edit_modal.schema.required')),
    is_published: z.boolean().optional(),
    is_scheduled: z.boolean().optional(),
    has_partner: z.boolean().optional(),
    partner_uuid: z.string().optional(),
    team_uuid: z.string().optional(),
    file: z
      .any()
      .refine(
        file => (file && ACCEPTED_IMAGE_TYPES.includes(file.type)) || !file,
        t('pages.application_store.components.product_store_edit_modal.schema.required_file'),
      ),
    publish_at: z
      .string()
      .optional()
      .transform(value => (value === '' ? undefined : value)),
  })
  .superRefine((values, ctx) => {
    if (values.is_scheduled && !values?.publish_at) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['publish_at'],
        message: t('pages.application_store.components.product_store_edit_modal.schema.required_date'),
      });
    }

    if (values.has_partner && !values?.partner_uuid) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['partner_uuid'],
        message: t('pages.application_store.components.product_store_edit_modal.schema.required_partner'),
      });
    }

    values.price = values.price.replace(',', '.');
    if (isNaN(parseFloat(values.price)) || parseFloat(values.price) <= 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['price'],
        message: t('pages.application_store.components.product_store_edit_modal.schema.required'),
      });
    }
  });

export type ModalFormData = z.infer<typeof modalFormSchema>;
